import { GlobalCartState, GlobalCartAction, GlobalCartActionKind } from './constants';
import { HYDRATE } from 'next-redux-wrapper';

const initialState: GlobalCartState = {
  totalCartCount: 0,
  entries: [],
  selectedEntries: [],
  appliedVouchers: [],
};

function globalCartReducer(state = initialState, action: GlobalCartAction): GlobalCartState {
  switch (action.type) {
    case HYDRATE:
      return { ...state, ...action.payload.globalCart };
    case GlobalCartActionKind.RESET_GLOBAL_CART_STATE:
      return initialState;
    case GlobalCartActionKind.SET_GLOBAL_CART_ALL_STATE:
      return {
        ...state,
        entries: action.entries,
        branch: action.branch,
        totalCartCount: action.totalCartCount,
        appliedVouchers: action.appliedVouchers,
        stampDutyFee: action.stampDutyFee,
        subTotal: action.subTotal,
        totalDiscounts: action.totalDiscounts,
        strikeThroughPrice: action.strikeThroughPrice,
        selectedEntries: action.selectedEntries
          ? action.selectedEntries
          : (action.entries
              .map((item) => (state.selectedEntries.includes(item.uuid) ? item.uuid : undefined))
              .filter(Boolean) ?? []),
      };
    case GlobalCartActionKind.SET_GLOBAL_CART_ALL_ENTRIES:
      if (action.entries) {
        return { ...state, entries: action.entries };
      }
      return state;
    case GlobalCartActionKind.SET_GLOBAL_CART_ENTRIES:
      if (action.entries) {
        return { ...state, entries: action.entries };
      }
      return state;
    case GlobalCartActionKind.SET_GLOBAL_CART_TOTAL_COUNT:
      if (action.totalCartCount) {
        return { ...state, totalCartCount: action.totalCartCount };
      }
      return state;
    case GlobalCartActionKind.SET_GLOBAL_CART_BRANCH:
      if (action.branch) {
        return { ...state, branch: action.branch };
      }
      return state;
    case GlobalCartActionKind.SET_GLOBAL_CART_SELECTED_ENTRIES:
      if (action.selectedEntries) {
        localStorage.setItem('selectedEntries', JSON.stringify(action.selectedEntries));
        return { ...state, selectedEntries: action.selectedEntries };
      }
      return state;
    case GlobalCartActionKind.SELECT_GLOBAL_CART_ENTRY:
      if (action.uuid) {
        const isSelectedBefore = state.selectedEntries.includes(action.uuid);
        let updatedSelectedEntries = [];
        if (isSelectedBefore) {
          updatedSelectedEntries = [
            ...state.selectedEntries.filter((item) => item !== action.uuid),
          ];
        } else {
          updatedSelectedEntries = [...state.selectedEntries, action.uuid];
        }
        localStorage.setItem('selectedEntries', JSON.stringify(updatedSelectedEntries));
        return { ...state, selectedEntries: updatedSelectedEntries };
      }
      return state;
    case GlobalCartActionKind.SET_GLOBAL_CART_CODE:
      if (action.cartCode) {
        return { ...state, cartCode: action.cartCode };
      }
      return state;
    case GlobalCartActionKind.SET_GLOBAL_CART_IS_GLOBAL_CART_PENDING:
      return { ...state, isGlobalCartPending: action.isGlobalCartPending };
    default:
      return state;
  }
}

export default globalCartReducer;
